import appConstants from '../appConstants';
import * as types from '../constants/commonConstants';
//import allCssColorThemeData from "../theme/styles/theme.json";
import allLangDirectionData from "../theme/styles/direction.json";
import { getFormattedRate, getPureNumber, getMinMaxFractionDigits } from '../utils/utils';
const arr = [];
let openedArray = [];
const initialState = {
  forcedLogout:false,
  killSession:{Key:false,Msg:"",Flag:false},
  settingmodal:false,
  setLockState:1,
  unlockModalFlag:false,
  openedWidgets:[],
  language:'',
  showUnlockMsg: false,
  unlockErrorMsg:'',
  //allCssColorThemeData:allCssColorThemeData,
  allLangDirectionData:allLangDirectionData,
  allCssColor:[],
  selectedCssColor:'',
  selectedCssColorTheme:{},
  isprofileFlag:false,
  unlockScreenFlag:false,
  checkLockFlag:false,
  selectedLang:{},
  stkCodeWisePair:[],
  errorLogs:[],
  deliveries: [],
  marginForPD: [],
  showPlaceRequestSuccessModal: false,
  placedRequestData: {},
  unitDetails: []
};

const closeAllChilds = (child) => {
  arr.push(child);
  return arr;
};

const openedWidget = (key, state) => {
  if (state === 'open') {
    openedArray.push(key);
  } else {
    openedArray = openedArray.filter((item) => {
      return item !== key;
    });
  }
  localStorage.setItem('openedWidgets', JSON.stringify(openedArray));
  return openedArray;
};

const getStkWisePairList = (data) =>{
  var stkCodeWisePair = new Map();
  for(let i=0;i<data.length;i++){
    stkCodeWisePair.set(data[i].stk_Type,data[i]);
  }
  return stkCodeWisePair;
}

const transformBCMToAPIDelivery = (bcmData) => {
  if (!bcmData || !bcmData.BCM || !bcmData.DATA) return null;

  return {
    DRN: bcmData.DRN || '',
    TRID: bcmData.TRID || '',
    CMDTY: bcmData.CMDTY || '',
    AC: bcmData.AC || '',
    AD: bcmData.AD || '',
    TOTAL_GQ: (bcmData.TOTAL_GQ || 0).toString(),
    TOTAL_PAMT: (bcmData.TOTAL_PAMT || 0).toString(),
    TOTAL_FC_PAMT: (bcmData.TOTAL_FC_PAMT || 0).toString(),
    LOC: bcmData.LOC || '',
    LOC_DESC: bcmData.LOC_DESC || '',
    DATE: bcmData.DATE || '',
    TIME: bcmData.DLT || '',
    TZ: bcmData.TZ || '',
    DOCS: bcmData.DOCS || [],
    DATA: bcmData.DATA.map(item => ({
      SC: item.SC,
      PQ: item.PQ,
      GQ: item.GQ,
      PREM: item.PREM,
      PUNIT: item.PUNIT,
      PAMT: item.PAMT,
      FC_PAMT: item.FC_PAMT,
    })),
    CURRENCY: bcmData.CURRENCY || 'USD',
    RMK: bcmData.RMK || '',
    STATUSDESC: bcmData.STATUSDESC || '',
    STATUSCODE: bcmData.STATUSCODE || '',
    ADD_CHARGES: bcmData.ADD_CHARGES || '',
    ADD_RMK: bcmData.ADD_RMK || '',
    LOC_ADDRESS: bcmData.LOC_ADDRESS || '',
    LOC_CONTACTS: bcmData.LOC_CONTACTS || [],
    TS: bcmData.TS || '',
  };
};

const transformUnitDetails = (unitData) => {
  return unitData.reduce((acc, item) => {
    acc[item.unitCode] = item.unitConvFactor;
    return acc;
  }, {});
}

const transformPremiumDetails = (newData) => {
  const { physicalCodes, premiums } = newData;

  // Create lookup for physicalCodes by stockType-stockCode
  const physicalMap = new Map();
  for (const { stockType, stockTypeName, stockCodes, stockRateFormat, stockQtyFormat, stockQtyRound, stockRateRound } of physicalCodes) {
    for (const { stockCode, convFactor } of stockCodes) {
      physicalMap.set(`${stockType}-${stockCode}`, {
        stockType,
        stockTypeName,
        stockCode,
        convFactor,
        stockRateFormat,
        stockQtyFormat,
        stockQtyRound,
        stockRateRound
      });
    }
  }

  // Group result by stockType
  const resultMap = new Map();

  for (const { stockType, stockCode, prem, unit } of premiums) {
    const phys = physicalMap.get(`${stockType}-${stockCode}`);
    if (!phys) continue; // skip if no match in physicalCodes

    if (!resultMap.has(stockType)) {
      resultMap.set(stockType, {
        STK_TYPE: stockType,
        DESC: phys.stockTypeName,
        STOCK_RATE_FORMAT: phys.stockRateFormat,
        STOCK_QTY_FORMAT: phys.stockQtyFormat,
        STOCK_QTY_ROUND: phys.stockQtyRound,
        STOCK_RATE_ROUND: phys.stockRateRound,
        DATA: []
      });
    }

    resultMap.get(stockType).DATA.push({
      STK: stockCode,
      RATES: [
        {
          PREM: prem,
          CONV_FACT: phys.convFactor,
          UNIT: unit
        }
      ]
    });
  }

  return Array.from(resultMap.values());
};

const transformDeliveryData = (data) => {
    const transformedData = data.map(item => {
        const DATA = item.DATA
        const config = {
            GQ: { ...getMinMaxFractionDigits(item?.stockQtyFormat), roundOff: item?.stockQtyRound },
            PAMT: { ...getMinMaxFractionDigits(item?.stockRateFormat), roundOff: item?.stockRateRound },
            PREM: { ...getMinMaxFractionDigits(item?.stockRateFormat), roundOff: item?.stockRateRound },
            ADD_CHARGES: { ...getMinMaxFractionDigits(item?.stockRateFormat), roundOff: item?.stockRateRound },
        };
        for (let dataPoint of DATA) {
            dataPoint.GQ = getFormattedRate(dataPoint.GQ, config["GQ"].minimumFractionDigits, config["GQ"].maximumFractionDigits, config["GQ"].roundOff);
            dataPoint.PAMT = getFormattedRate(dataPoint.PAMT, config["PAMT"].minimumFractionDigits, config["PAMT"].maximumFractionDigits, config["PAMT"].roundOff);
            dataPoint.PREM = getFormattedRate(dataPoint.PREM, config["PREM"].minimumFractionDigits, config["PREM"].maximumFractionDigits, config["PREM"].roundOff);
        }
        return ({
            ...item,
            TOTAL_PAMT: getPureNumber(item.TOTAL_PAMT),
            TOTAL_GQ: getPureNumber(item.TOTAL_GQ),
            ADD_CHARGES: getFormattedRate(item.ADD_CHARGES, config["ADD_CHARGES"].minimumFractionDigits, config["ADD_CHARGES"].maximumFractionDigits, config["ADD_CHARGES"].roundOff),
            DATA
        })
    });
    return transformedData;
}

const addFormatterToData = (dataObject) => {
    const { data, deliveries } = dataObject;
    const stockTypeMap = new Map();
    data.forEach(stockType => {
        stockTypeMap.set(stockType.stockTypeName, stockType);
    });

    const formattedDeliveries = deliveries.map(delivery => {
        const stockTypeInfo = stockTypeMap.get(delivery.CMDTY);
        const updatedDelivery = { ...delivery, ...stockTypeInfo };
        return updatedDelivery;
    })
    return formattedDeliveries
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.WIDGET_THEMING_SUCCESS:
      localStorage.setItem('openedWidgets', []);
      return {
        ...state
      };
      case types.LOG_FILE_CREATE:
        return{
          ...state,
          errorLogs: [...state.errorLogs, action.errorObj]
        };
      case types.SEND_LOG:
        return{
          ...state,
        };
      case types.SEND_LOG_SUCCESS:
        return{
          ...state,
          errorLogs:[]
        };
      case types.SEND_LOG_FAILURE:
        return{
          ...state,
          errorLogs:[]
        };
    case types.WIDGET_THEMING_FAILURE:
      return {
        ...state,
      };
    case types.GET_WIDGET_THEMING:
      return {
        ...state,
      };
    case types.GET_WIDGET_THEMING_SUCCESS:
      return {
        ...state
      };
    case types.GET_WIDGET_THEMING_FAILURE:
      return {
        ...state,
      };
    case types.HANDLE_MODAL:
      return {
        ...state,
        modal: action.status
      };

    case types.HIDE_MODAL:
      return {
        ...state,
        modal: false
      };
    case types.SHOW_DIALOG:
      return {
        ...state,
        showDialog: true
      };
    case types.HIDE_DIALOG:
      return {
        ...state,
        showDialog: false
      };
    case types.NAVIGATE_TRADE_REPORT:
      return {
        ...state,
        navigationStatus: action.option,
      };
    case types.POPUP_WINDOW_HANDLE:
	    return {
	      ...state,
	      handler: closeAllChilds(action.opened),
	      poppedOut: action.opened,
	      openedWidgets: openedWidget(action.key, 'open')
    };
    case types.POPUPCLOSE_HANDLE:
    	return {
  	  ...state,
      openedWidgets: openedWidget(action.key, 'close')
	    };

    case types.FORCED_LOGOUT:
     return {
       ...state,
       forcedLogout:true
     }
     case types.CL_FORCED_LOGOUT:
     return{
       ...state,
       forcedLogout:false
     }
     case types.NOCHANGE:
     return{
       ...state,
     }
     case types.KILL_SESSION:
     var obj={};
     obj.Key=action.key;
     obj.Msg=action.msg;
     obj.Flag=action.flag;
     return{
       ...state,
       killSession:obj,
     };
	 case types.CLEAR_KILL_SESSION:
	  var obj={};
     obj.Key=false;
     obj.Msg="";
     obj.Flag=false;
	   return{
       ...state,
       killSession:obj,
     };
   case types.LOAD_LOCK_FLAG:
   return{
     ...state,
     setLockState:action.flag,
     checkLockFlag:true
   }
     case types.LOCK_UNLOCK_FLAG:
     return{
       ...state,
       unlockModalFlag:action.setFlag
     }
     case types.UNLOCK_PSD_SUCCESS:
     return{
       ...state,
       showUnlockMsg:action.successFlag
     }
     case types.LOAD_LANG:
     return{
       ...state,
       language:action.lang
     }
     case types.UNLOCK_VERIFY:
     return{
       ...state
     }
     case types.UNLOCK_VERIFY_SUCCESS:
     var errorMsg='';
     var checkLock = false;
     if(action.result.dataObject.ST === 0){
       errorMsg="invalidPassword";
       checkLock = true ;
     }
     return{
       ...state,
       setLockState:action.result.dataObject.ST,
       unlockErrorMsg:errorMsg,
       checkLockFlag:checkLock,
     }
     case types.UNLOCK_VERIFY_FAILURE:
     return{
       ...state
     }
	 case types.RESET_UNLOCK:
     return{
       ...state,
       setLockState:1
     }
     case types.GET_ALL_COLORS:
     return{
       ...state
     }
     case types.GET_ALL_COLORS_SUCCESS:
     return{
       ...state,
       allCssColor :action.result.dataObject
     }
     case types.GET_ALL_COLORS_FAILURE:
     return{
       ...state
     }
    case types.CHANGE_THEME:
    return{
      ...state,
      selectedCssColor:action.selectedCssColor
    }
    case types.SELECTED_CSS_THEME:
    return{
     ...state,
     selectedCssColorTheme:action.selectedCssColorTheme
    }
    case types.SELECTED_LANG:
    return{
     ...state,
     selectedLang:action.selectedLang
    }
    case types.IS_PROFILE_CLIKED:
    return{
     ...state,
     isprofileFlag:action.isprofileFlag
    }
    case types.UNLOCK_MODAL_STATUS:
      return {
        ...state,
        unlockScreenFlag: action.unlockScreenFlag,
        unlockErrorMsg:'',
      };
    case types.UNLOCK_CHANGE_STATUS:
      return{
        ...state,
        checkLockFlag:action.checkLockFlag
      };
    case types.CHANGE_CALENDAR_FLAG:
     return{
       ...state,
       openCalender:action.flag,
       widgetKeyValue:action.keyValue
     }
   case types.LOAD_STKWISEPAIR:
       return {
         ...state
       };
   case types.LOAD_STKWISEPAIR_SUCCESS:
   return {
       ...state,
       stkCodeWisePair: getStkWisePairList(action.result.dataObject)
     };
   case types.LOAD_STKWISEPAIR_FAILURE:
     return {
       ...state
     };
    case types.GET_MARGIN_FOR_PD:
      return {
        ...state,
      };
    case types.GET_MARGIN_FOR_PD_SUCCESS:
      return {
        ...state,
        marginForPD: action.result.dataObject
      };
    case types.GET_MARGIN_FOR_PD_FAILURE:
      return {
        ...state,
        marginForPD: []
      };
    case types.LOAD_DELIVERIES:
      return {
        ...state,
        deliveries: [],
      }
    case types.LOAD_DELIVERIES_SUCCESS:
        const formatterAddedData = addFormatterToData(action.result.dataObject);
      return {
        ...state,
        stockTypeData: action.result.dataObject.data,
        deliveries: transformDeliveryData(formatterAddedData),
      }
    case types.LOAD_DELIVERIES_FAILURE:
      return {
        ...state,
      }
    case types.GET_PREMIUM_DETAILS:
      return {
        ...state,
        premiumDetails: [],
        unitDetails: []
      }
    case types.GET_PREMIUM_DETAILS_SUCCESS:
      const data = transformPremiumDetails(action.result.dataObject)
      return {
        ...state,
        premiumDetails: data,
        unitDetails: transformUnitDetails(action.result.dataObject?.units || [])

      }
    case types.GET_PREMIUM_DETAILS_FAILURE:
      return {
        ...state,
        premiumDetails: [],
        unitDetails: []
      }
    case types.GET_LOCATION_DETAILS:
      return {
        ...state,
        locationDetails: []
      }
    case types.GET_LOCATION_DETAILS_SUCCESS:
      return {
        ...state,
        locationDetails: action.result.dataObject
      }
    case types.GET_LOCATION_DETAILS_FAILURE:
      return {
        ...state,
        locationDetails: []
      }
    case types.PLACE_REQUEST:
      return {
        ...state,
      }
    case types.PLACE_REQUEST_SUCCESS:
      return {
        ...state,
        showPlaceRequestSuccessModal: true,
        placedRequestData: action.payload
      }
    case types.HIDE_PLACE_REQUEST_SUCCESS_MODAL:
      return {
        ...state,
        showPlaceRequestSuccessModal: false,
        placedRequestData: {}
      }
    case types.PLACE_REQUEST_FAILURE:
      return {
        ...state,
      }
    case types.CANCEL_DELIVERY_REQUEST:
      return {
        ...state,
      }
    case types.CANCEL_DELIVERY_REQUEST_SUCCESS:
      return {
        ...state,
      }
    case types.CANCEL_DELIVERY_REQUEST_FAILURE:
      return {
        ...state,
      }
    case types.UPDATE_PHYSICAL_DELIVERY_DATA: {
      const bcmData = action.msg;
      if (!bcmData || !bcmData.BCM || bcmData.BCM === appConstants.PHYSICAL_DELIVERY_REQUEST_RECEIVED || bcmData.BCM === appConstants.PHYSICAL_DELIVERY_MARGIN_CHECKS_FAIL) {
        return {
          ...state
        };
      }
      const updatedEntry = transformBCMToAPIDelivery(bcmData);
      if (!updatedEntry) return state;

      // If same TRID already exists, replace it; else add new
      const existingIndex = state.deliveries.findIndex(
        (item) => item.TRID === updatedEntry.TRID
      );

      let updatedDeliveries = [...state.deliveries];
      if (existingIndex !== -1) {
        updatedDeliveries[existingIndex] = updatedEntry;
      } else {
        updatedDeliveries.push(updatedEntry);
      }
      const formatterAddedData = addFormatterToData({ data: state.stockTypeData, deliveries: updatedDeliveries });
      return {
        ...state,
        deliveries: transformDeliveryData(formatterAddedData),
      };
    }
    case types.UPDATE_OPEN_POSITIONS: {
      const message = JSON.parse(action.message.data);

      if (!message || !message.BCM || message.BCM !== '901') {
        return {
          ...state
        };
      }

      let data = JSON.parse(message.data.mrgn.CURR_BAL);

      // Filter only items where NP != 0
      const updatedPositions = data.STKA
        .filter(item => Number(item.NQ) !== 0)
        .map(item => ({
          suf_desc: item.D,
          fc_amt: item.NQ
        }));

      return {
        ...state,
        marginForPD: updatedPositions
      };
    }
    default:
		    return state;
		}
  }
